import React from "react";
import style from "./index.module.scss";
import { Alert, Col, Row } from "antd";

export default function UploadExcelModal() {
    return (
        <div>
            <Alert
                message="重点说明: 修改分数后，原主观题分数将被锁定无法修改"
                style={{ marginBottom: 15 }}
            />
            <Row className={style.row}>
                <Col span={22} className={style.label}>
                    1.
                    <a
                        href="/assets/作业分数修改模板.xlsx"
                        target="_blank"
                        download>
                        点击下载
                    </a>
                    《作业分数修改模板》
                </Col>
            </Row>
            <Row className={style.row}>
                <Col span={22} className={style.label}>
                    <i className={style.required}>*</i>
                    2.在导入模板补充好数据后上传文件
                </Col>
            </Row>
        </div>
    );
}
